import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getEncoders = state => state.omnitecEncoders

export const selectEncodersFetching = state => path(['omnitecEncoders', 'isFetching'], state)

export const selectEncoders = createSelector(getEncoders, encoders => {
    if (!(isEmpty(encoders.entities) || isEmpty(encoders.result))) {
        const items = encoders.entities.omnitecEncoders
        return items
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/omnitecSelectors/omnitecEncoders.js